import { useSelector } from 'react-redux';
import { selectors } from "../../redux";

const useConfigName = () => {
    return useSelector(selectors.configName.getConfigName);
}

export default useConfigName;